import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { paymentMethodsTypes } from 'actions/types'

const initialState = []
const baseType = paymentMethodsTypes.FETCH_PAYMENT_METHODS

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
})

export default reducer
